import { Capacitor } from "@capacitor/core";

// True inside the native Capacitor shell (iOS/Android), false in a browser.
// Drives the app-shell (bottom nav, fixed viewport) vs website-shell (top nav,
// hero, footer, document scroll) split for record shops.
export function isNativeApp(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}
